import { useQuery } from "@tanstack/react-query";
import invariant from "tiny-invariant";
import { useAccount } from "wagmi";

import { convertHexToBech32 } from "shared/web3/utils";

import { DelegationTotalRewards200 } from "./gen";

export const useDelegatorRewardsQuery = () => {
  const { address } = useAccount();
  return useQuery({
    queryKey: ["cosmos", "distribution", "delegators", "rewards", address],
    queryFn: async () => {
      invariant(address);
      const bech32Address = convertHexToBech32(address);
      const response = await fetch(
        `/cosmos-api/cosmos/distribution/v1beta1/delegators/${bech32Address}/rewards`
      );
      const data: DelegationTotalRewards200 = await response.json();

      return data;
    },
    enabled: Boolean(address),
  });
};
